import { useContext } from 'react';

import EventContext from '../Event.context';

export const useEventDispatch = () => {
  const [_subscribe, _unsubscribe, dispatch] = useContext(EventContext);

  return dispatch;
};
